import { accent } from "../hooks/tokens.js";

// Header nav: screen flags used by App.jsx to pick a screen component, the
// top-level nav links, and the "Outils ▾" dropdown (Header.jsx, Home.jsx).
export function buildNavView(ctx) {
  const { s, patch, nav, course, goCourse, dismissToast } = ctx;
  return {
    syncLoading: s.syncLoading, syncError: s.syncError,
    toast: s.toast, dismissToast,
    isHome: s.screen === "home", isArticle: s.screen === "article",
    isCourse: s.screen === "course", isIndex: s.screen === "index",
    isAuth: s.screen === "auth",
    isTools: s.screen === "tools", isTshoot: s.screen === "tshoot", isXlate: s.screen === "xlate",
    isCompare: s.screen === "compare", isDiagrams: s.screen === "diagrams", isGraph: s.screen === "graph",
    isRevise: s.screen === "revise", isCertif: s.screen === "certif",
    isNotFound: s.screen === "notfound", isProfile: s.screen === "profile",
    goHome: () => nav("home"),
    goAuth: () => nav("auth"),
    goCourse: () => goCourse(course.id),
    goIndex: () => nav("index"),
    goRevise: () => nav("revise"),
    goCertif: () => nav("certif"),
    goProfile: () => nav("profile"),
    toolsMenuOpen: s.toolsMenuOpen,
    toggleToolsMenu: () => patch({ toolsMenuOpen: !s.toolsMenuOpen }),
    toolsNavColor: ["tools", "tshoot", "xlate", "compare", "diagrams", "graph"].indexOf(s.screen) >= 0 ? accent : "oklch(0.45 0.015 60)",
    toolLinks: [
      { label: "Boîte à outils calculs", desc: "Sous-réseaux, VLSM, MTU et overhead", screen: "tools" },
      { label: "Arbres de décision", desc: "Dépannage guidé, question par question", screen: "tshoot" },
      { label: "Traducteur de commandes", desc: "IOS-XE ↔ Junos ↔ NX-OS", screen: "xlate" },
      { label: "Fiches comparatives", desc: "OSPF vs IS-IS, VLAN vs VXLAN…", screen: "compare" },
      { label: "Schémas de référence", desc: "Spine-leaf, campus, WAN hybride", screen: "diagrams" },
      { label: "Graphe de liens", desc: "Ce qui se lit avec quoi", screen: "graph" },
    ].map((t) => ({ ...t, onClick: () => nav(t.screen) })),
  };
}
